<template>
  <div class="SellReportPage page">
    <div class="page-title">
      <span>Orders Report</span>
      <UiDropdownCurrency :currencyRates="getCurrencyRates" :getCurrencies="getCurrencies" @getData="selectCurrency"/>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <div class="column-filter">
      <UiReportList :reportList="reportList" />
      <div class="column-filter-wrapper">
        <button class="btn btn-csv customize-button" @click="toggleColumnFilter()">
          {{ $t('customize') }}
        </button>
        <UiButtonCustomize :isShowColumnsSelect="isShowColumnsSelect" :fields="fields"/>
      </div>
    </div>
    <UiChart v-if="!loading && (report && report.items && typeof (report.items) === 'object')" :series="prepareChartSeries(report)" :options="prepareChartOptions(report)"/>
    <UiTableReportCommon :report="reportData" :colsData="visibleFields"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiChart from '@/components/UiChart'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiReportList from '@/components/UiReportList'
import UiTableReportCommon from '@/components/UiTableReportCommon'
import UiButtonCustomize from '@/components/UiButtonCustomize'
import UiDropdownCurrency from '@/components/UiDropdownCurrency'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'TotalRevenuePage',
  components: {
    UiFilterbar,
    UiChart,
    UiReportList,
    UiTableReportCommon,
    UiButtonCustomize,
    UiDropdownCurrency
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      filterType: 'DATE',
      type: 'products',
      isShowColumnsSelect: false,
      reportList: reportListData.orders,
      fields: [
        { key: 'totalRevenue', label: i18n.t('total_revenue'), visible: false },
        { key: 'totalTax', label: i18n.t('tax'), visible: false },
        { key: 'netRevenue', label: i18n.t('net_revenue'), visible: false },
        { key: 'avgOrderValue', label: i18n.t('avg_order_value'), visible: false },
        { key: 'orderCount', label: i18n.t('number_of_orders'), visible: false },
        { key: 'avgItemCount', label: i18n.t('avg_number_of_item_per_order'), visible: false },
        { key: 'revNewCustomer', label: i18n.t('new_customer'), visible: false },
        { key: 'revReturnCustomer', label: i18n.t('returning_customer'), visible: false },
        { key: 'totalRefund', label: i18n.t('refund'), visible: true },
        { key: 'totalDiscount', label: i18n.t('discount'), visible: false }
      ],
      filteredFields: [],
      reportData: {}
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates',
      getIsChangeStore: 'report/getIsChangeStore'
    }),
    visibleFields () {
      return this.fields.filter(field => field.visible)
    }
  },
  watch: {
    report: function (news, old) {
      if (news != null && this.getIsChangeStore) {
        this.reportData = news
      }
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      setCustomizeData: 'report/setCustomizeData'
    }),
    selectCurrency () {
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...this.day
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds) {
      this.day = day
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      }).then(() => {
        this.reportData = {}
        this.setCustomizeData(this.visibleFields)
        setTimeout(() => {
          this.reportData = this.report
        }, 100)
      })
    },
    toggleColumnFilter () {
      this.isShowColumnsSelect = !this.isShowColumnsSelect
    },
    documentClick (e) {
      const el = this.$refs.columnsList
      const target = e.target
      if (el && el !== target && !el.contains(target)) {
        this.isShowColumnsSelect = false
      }
    },
    formartDate (date) {
      return moment(new Date(moment(date).toDate().toUTCString())).format('MMM DD YYYY')
    },
    formatTotal (total) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(currentCurrent?.rate || '1')).toFixed(2), { maxFraction: 2 })}`
    },
    prepareChartOptions (reports) {
      const dateList = reports && reports.items ? Object.keys(reports.items).map(item => item.length < 8 ? item : this.formartDate(item)) : []
      return {
        chart: {
          id: 'product-sold-chart',
          type: 'bar',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        dataLabels: {
          style: {
            colors: ['#000000']
          },
          formatter: value => { return this.formatTotal(value) }
        },
        plotOptions: {
          bar: {
            columnWidth: dateList.length === 1 ? '15%' : dateList.length <= 3 ? '30%' : '70%'
          }
        },
        noData: {
          text: 'No data'
        },
        xaxis: {
          categories: dateList
        },
        yaxis: {
          labels: {
            formatter: value => { return this.formatTotal(value) }
          }
        }
      }
    },
    prepareChartSeries (reports) {
      const valueList = reports && reports.items ? Object.keys(reports.items).map(item => reports.items[item].totalRefund || 0) : []
      return [{
        name: i18n.t('refund'),
        data: valueList
      }]
    }
  },
  created () {
    const self = this

    window.addEventListener('click', function (e) {
    // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.isShowColumnsSelect = false
      }
    })
  },
  destroyed () {
    // important to clean up!!
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter {
    display: flex;
    justify-content: space-between;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
</style>
